
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {UsuarioComponent} from "../usuario/usuario.component";
import {ProductoComponent} from "../producto/producto.component";
import {CategoriaComponent} from "../categoria/categoria.component";
import {EmpleadoComponent} from "../empleado/empleado.component";
import {TrasladoComponent} from "../traslado/traslado.component";
import {TiendaComponent} from "../tienda/tienda.component";
import {ProvedorComponent} from "../provedor/provedor.component";
import {GastoComponent} from "../gasto/gasto.component";
import {HistorialComponent} from "../historial/historial.component";
import {ListaPrecioComponent} from "../lista-precio/lista-precio.component";
import {OrdenCompraComponent} from "../orden-compra/orden-compra.component";
import {InventarioComponent} from "../inventario/inventario.component";
import {InicioComponent} from "../inicio/inicio.component";
import {POSComponent} from "../pos/pos.component";
import {LoginComponent} from "../Login/login.component";
import {ClienteComponent} from "../cliente/cliente.component";
import {ComboComponent} from "../combo/combo.component";
import {SeparadoComponent} from "../separado/separado.component";
import {AuthGuard} from "../Login/auth.guard";
import {AppComponent} from "../app.component";
import {ConfiguracionComponent} from "../configuracion/configuracion.component";
import {ListaFacturasComponent} from "../lista-facturas/lista-facturas.component";
import {ReportesComponent} from "../reportes/reportes.component";

/*se importan los componentes creados */


const appRoutes: Routes = [

  { path : 'login' , component: AppComponent},
  { path : 'inicio' , component: InicioComponent, canActivate: [AuthGuard]},
  { path : 'usuario' , component: UsuarioComponent, canActivate: [AuthGuard]},
  { path : 'producto' , component: ProductoComponent, canActivate: [AuthGuard]},
  { path : 'categoria' , component: CategoriaComponent, canActivate: [AuthGuard]},
  { path : 'empleado' , component: EmpleadoComponent, canActivate: [AuthGuard]},
  { path : 'gasto' , component: GastoComponent, canActivate: [AuthGuard]},
  { path : 'historial' , component: HistorialComponent, canActivate: [AuthGuard]},
  { path : 'listaPrecio' , component: ListaPrecioComponent, canActivate: [AuthGuard]},
  { path : 'ordenCompra' , component: OrdenCompraComponent, canActivate: [AuthGuard]},
  { path : 'provedor' , component: ProvedorComponent, canActivate: [AuthGuard]},
  { path : 'tienda' , component: TiendaComponent, canActivate: [AuthGuard]},
  { path : 'traslado' , component: TrasladoComponent, canActivate: [AuthGuard]},
  { path : 'inventario' , component: InventarioComponent, canActivate: [AuthGuard]},
  { path : 'pos/:id' , component: POSComponent, canActivate: [AuthGuard]},
  { path : 'cliente' , component: ClienteComponent, canActivate: [AuthGuard]},
  { path : 'combo' , component: ComboComponent, canActivate: [AuthGuard]},
  { path : 'separado' , component: SeparadoComponent, canActivate: [AuthGuard]},
  { path : 'configuracion/:id' , component: ConfiguracionComponent, canActivate: [AuthGuard]},
  { path : 'factura/:id' , component: ListaFacturasComponent, canActivate: [AuthGuard]},
  { path : 'reporte' , component: ReportesComponent, canActivate: [AuthGuard]},

  // otherwise redirect to home
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports : [
    RouterModule.forRoot(appRoutes)
  ],
  exports : [
    RouterModule
  ]
})
export class RoutingModule{}




// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/navbar/routing.module.ts